/** Sensitive code-nav fields encrypted the same way as cloud WebSocket code-nav responses. */
export const SHORTCUT_CODE_NAV_E2EE_FIELDS = [
  'definition',
  'definitions',
  'references',
  'symbols',
  'confidentTarget',
] as const;
